module.exports = __webpack_public_path__ + "static/media/burlingame3.0e5f65d6.jpg";